import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Button from '../common/Button';

const Header = () => {
  const { user, logout, hasRole } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const displayName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'User';
  const getInitials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <header className="fixed top-0 left-0 right-0 z-40 h-16 bg-white shadow-sm border-b border-gray-200">
      <div className="h-full px-6 flex justify-between items-center">
        <div>
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="flex items-center"
            aria-label="Go to Submit Status"
          >
            <img
              src="Prokopto-logo.png"
              alt="Top3 Logo"
              className="h-8 w-8 mr-2"
            />
            <span className="text-2xl font-bold text-gray-900">
              Top3 Statuses
            </span>
          </button>
          {/* <p className="text-sm text-gray-600">
            Welcome, {user?.firstName} {user?.lastName}
          </p> */}
        </div>

        
        <div className="flex items-center gap-4">
          {hasRole('Admin') && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/dashboard')}
            >
              Employee Panel
            </Button>
          )}
          {hasRole('Admin') && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/admin/users')}
            >
              Admin Panel
            </Button>
          )}
          <div className="relative" ref={menuRef}>
            <button
              type="button"
              onClick={() => setMenuOpen((open) => !open)}
              className="flex items-center justify-center h-9 w-9 rounded-full bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700"
            >
              {getInitials(displayName)}
            </button>
            {menuOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-white border rounded-lg shadow-lg z-10">
                <div className="px-4 py-3 border-b">
                  <p className="text-sm text-gray-500">Welcome</p>
                  <p className="font-semibold text-gray-900">{displayName}</p>
                  <p className="text-xs text-gray-500">{user?.email}</p>
                </div>
                <div className="py-2">
                  <button
                    type="button"
                    onClick={() => {
                      setMenuOpen(false);
                      navigate('/profile');
                    }}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
                  >
                    Profile
                  </button>
                  <button
                    type="button"
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-50"
                  >
                    Logout
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
